<template>
   <div id="pdfviewer"></div>
</template>

<script setup>
import { defineProps, onMounted } from "vue";
import PDFObject from "pdfobject";

const props = defineProps({
   pdfLink: String,
});

onMounted(() => {
   PDFObject.embed(props.pdfLink, "#pdfviewer", { forcePDFJS: true });
});
</script>

<style scoped>
#pdfviewer {
   max-width: 100%;

   height: 600px;
   border: 10px solid rgba(0, 0, 0, 0.2);
   margin: 0;
}
</style>
